<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['emp.roleCostcode.roleCode']">
          <a-input v-model="model.roleKey" readOnly disabled/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['emp.roleCostcode.roleName']">
          <a-input v-model="model.roleName" readOnly disabled/>
        </a-form-item>
        <a-form-model-item :label="language['emp.roleCostcode.costcode']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="selectedCostcodes">
          <j-multi-select-tag :maxTagCount="20"
            v-model="model.selectedCostcodes"
            :options="costCodeOptions"
            :placeholder="language['common.pleaseChoose']+language['emp.roleCostcode.costcode']">
          </j-multi-select-tag>
        </a-form-model-item>


      </a-form>

    </a-spin>
  </a-modal>
</template>

<script>
  import { get, pick } from 'lodash';
  import { httpAction, getAction } from '@/api/manage'
  import { getDictItemsFromCache,ajaxGetDictItems } from '@/api/api'

  export default {
    name: "CmsRoleCostcodeBindModal",
    components: {
    },
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules:{
        },
        url: {
          edit: "/hhemp/basedatacms/cmsrolecostcode",
        },
        roleId:"",
        roleKey:"",
        roleName:"",
        costCodeOptions:[],
        costCodeList: []
      }
    },
    created () {
      this.initCostcodeList();
    },
    computed:{
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      roleCostcodeSet(roleId,roleKey,roleName){
        this.roleId = roleId;
        this.roleKey = roleKey;
        this.roleName = roleName;
        this.edit({roleId:this.roleId,roleKey:this.roleKey,roleName:this.roleName,selectedCostcodes: ''});

      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.getCmsRoleCostcodes(this.roleId);
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            httpurl+=this.url.edit;
            method = 'put';
            let formData = Object.assign(this.model, values);
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                //this.init();
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })



          }
        })
      },
      handleCancel () {
        this.close()
      },
      initCostcodeList(){
        ajaxGetDictItems('vnemp_login_costCode', null).then((res) => {
          if (res.success) {
            this.costCodeOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.label+'-'+item.value, value:item.value}
              return c;
            });
          }
        })
      },
      getCmsRoleCostcodes(roleId){
        getAction("/hhemp/basedatacms/getCmsRoleCostcodes",{roleId:roleId}).then((res)=>{
          if(res.success){
            this.model.selectedCostcodes = res.result.join(",");
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>